import { Component, OnInit } from '@angular/core';
import { SearchProductsService } from '../_services/searchProduct.service';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from 'ngx-translate-with-country';
import { Title } from '@angular/platform-browser';
import { BreadcrumbsService } from 'ng6-breadcrumbs';
import { DataStorageService } from '../_services/data-storage.service';
import { ProductService } from '../_services/product.service';

@Component({
  selector: 'app-search-product',
  templateUrl: './search-product.component.html',
  styleUrls: ['./search-product.component.scss']
})
export class SearchProductComponent implements OnInit {

  country: string;
  language: string;
  queryString: string;
  loading = true;
  products: any = [];
  query: any;
  SearchProduct: any;
  innerHeight: any;

  constructor(
    private _searchProductsService: SearchProductsService,
    private _ProductService: ProductService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    public titleService: Title,
    public breadcrumbsService: BreadcrumbsService,
    private dataStorageService: DataStorageService
  ) {
    this.innerHeight = (window.screen.height-375) + "px" ;

   }

  getAll(country: string, language: string): void {
    this._searchProductsService.getAll(country, language)
      .subscribe(
        resultArray => this.SearchProduct = resultArray,
        error => console.log('Error ::' + error)
      );
  }

  search(country, language, query) {
    this.loading = true;
    this._ProductService.search(country, language, query).subscribe(
      response => {
        this.loading = false;
        this.products = response;
        console.log(this.products);
      },
      error => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  ngOnInit() {
    this.queryString = this.dataStorageService.searchKey;
    this.route.params
      .subscribe(
        (params: Params) => {
          this.country = params['country'];
          this.language = params['language'];
          this.query = params['query'];
          this.search(this.country, this.language, this.query);
        }
      );
  }
}

